export const faq = {
  title: 'Frequently Asked Questions',
  subtitle: 'Find answers to common questions about our services',
  categories: {
    general: {
      title: 'General Questions',
      questions: [
        {
          question: 'What payment methods do you accept?',
          answer: 'We accept credit cards, PayPal, and bank transfers. All payments are processed securely through our payment gateway.'
        },
        {
          question: 'Do you offer refunds?',
          answer: 'Yes, we offer a 14-day money-back guarantee for most of our services. Specific terms apply to different services.'
        },
        {
          question: 'Where are your servers located?',
          answer: 'Our main datacenters are located in Italy (Milan) and Germany (Frankfurt), providing optimal coverage for European users.'
        },
        {
          question: 'How do I create an account?',
          answer: 'You can easily create an account through our client area. Simply click on "Register" and follow the steps to set up your account.'
        },
        {
          question: 'What currencies do you accept?',
          answer: 'We primarily bill in Euros (€), but also accept payments in USD ($) and GBP (£).'
        }
      ]
    },
    technical: {
      title: 'Technical Support',
      questions: [
        {
          question: 'How can I contact technical support?',
          answer: 'Our technical support team is available 24/7 through our ticketing system, email, and phone support.'
        },
        {
          question: 'What is your uptime guarantee?',
          answer: 'We guarantee 99.99% uptime for all our services, backed by our SLA (Service Level Agreement).'
        },
        {
          question: 'Do you provide DDoS protection?',
          answer: 'Yes, all our services include advanced DDoS protection up to 4 Tbps at no additional cost.'
        },
        {
          question: 'What is your average response time for support tickets?',
          answer: 'Our average response time is under 30 minutes for urgent issues and within 2 hours for regular support tickets.'
        },
        {
          question: 'Do you offer managed support?',
          answer: 'Yes, we offer managed support packages for all our hosting services, including server maintenance, updates, and security monitoring.'
        }
      ]
    },
    hosting: {
      title: 'Hosting Services',
      questions: [
        {
          question: 'Can I upgrade my hosting plan later?',
          answer: 'Yes, you can easily upgrade your hosting plan at any time through our client area.'
        },
        {
          question: 'Do you offer website migration services?',
          answer: 'Yes, we offer free website migration services for all hosting plans.'
        },
        {
          question: 'What control panel do you use?',
          answer: 'We use cPanel for web hosting and Pterodactyl Panel for game servers.'
        },
        {
          question: 'How often do you perform backups?',
          answer: 'We perform daily backups for all hosting services, and backups are retained for 30 days.'
        },
        {
          question: 'Can I host multiple domains on one account?',
          answer: 'Yes, our Business and Professional hosting plans support unlimited domains.'
        }
      ]
    },
    gameServers: {
      title: 'Game Servers',
      questions: [
        {
          question: 'How quickly are game servers activated?',
          answer: 'Game servers are activated instantly after payment confirmation.'
        },
        {
          question: 'Can I install custom mods?',
          answer: 'Yes, all our game servers support custom mods and plugins through the Pterodactyl Panel.'
        },
        {
          question: 'Do you offer server backups for game servers?',
          answer: 'Yes, we perform daily backups of all game servers, and you can also create manual backups through the control panel.'
        },
        {
          question: 'What is the minimum server slot count?',
          answer: 'Minimum slot counts vary by game. Minecraft starts at 10 slots, Rust at 50 slots, and CS2 at 12 slots.'
        },
        {
          question: 'Can I switch games on my server?',
          answer: 'Yes, you can switch between supported games at any time through the control panel.'
        }
      ]
    },
    security: {
      title: 'Security & Privacy',
      questions: [
        {
          question: 'How do you protect customer data?',
          answer: 'We implement industry-standard security measures, including encryption, firewalls, and regular security audits.'
        },
        {
          question: 'Do you offer SSL certificates?',
          answer: 'Yes, we provide free SSL certificates for all hosting plans through Let\'s Encrypt.'
        },
        {
          question: 'How do you handle GDPR compliance?',
          answer: 'We are fully GDPR compliant and implement all necessary measures to protect user data according to EU regulations.'
        },
        {
          question: 'What backup options are available?',
          answer: 'We offer both automated daily backups and manual backup options, with easy restore functionality.'
        },
        {
          question: 'How do you handle security incidents?',
          answer: 'We have a dedicated security team that monitors our infrastructure 24/7 and responds immediately to any security incidents.'
        }
      ]
    }
  }
};